import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';
import localeEsUS from '@angular/common/locales/es-US';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GuestService } from './services/guest.service';
import { PanelistService } from './services/panelist.service';
import { AngularHttpInterceptor } from './services/angular-http-interceptor';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { AngularErrorInterceptor } from './services/angular-error-interceptor';
import { AppInitService } from './services/app-init.service';
import {
  LoaderService,
  LoaderModule
} from 'potscommonui/src/app/component-library';
import { AppChildRouteGuard } from './services/app.routing.guard';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DataService } from './services/data.service';
import { AppErrorComponent } from './components/app-error/app-error.component';
import { AuthService } from './services/auth.service';
import { SharedService } from './services/shared.service';
import { AppConstants } from './constants/app-constants';

// the second parameter 'it' is optional
registerLocaleData(localeIT, 'it');
registerLocaleData(localeEsUS, 'es-US');

export function initializeApp(appInitService: AppInitService) {
  // console.log('initializer called');
  return () => appInitService.load();
}

export function HttpLoaderFactory(httpClient: HttpClient) {
 return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    LoaderModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    //DeviceDetectorModule.forRoot()
  ],
  providers: [
    AuthService,
    LoaderService,
    AppConstants,
    { provide: LOCALE_ID, useValue: 'it' },
    GuestService,
    AppChildRouteGuard,
    SharedService,
    PanelistService,
    DataService,
    DeviceDetectorService,
    [
      {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [AppInitService, HttpClient],
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AngularHttpInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AngularErrorInterceptor,
        multi: true
      }
    ]
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
